import type { LinkifyOptions } from 'linkify-it';

/**
 * linkify-it 6 turned off scheme-less links (`dashsocial.com`) and URL auth by default; users
 * type bare domains in captions and comments, so keep recognising what v5 did.
 */
export const LINKIFY_OPTIONS = {
  fuzzyLink: true,
  urlAuth: true,
} as const satisfies LinkifyOptions;
